import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { useNavigate } from "react-router-dom";
import users from "../../Utils/UserList.json";
import { deleteReportById, report } from "../../Services/api";
import DeleteIcon from "@mui/icons-material/Delete";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";
import TruncatedText from "../../Components/TruncatedText";

const Reports = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setData(users); // Load JSON data into state
  }, []);

  const deleteReport = async (rowData) => {
    try {
      console.log(rowData._id);
      setLoading(true);
      const result = await deleteReportById(rowData._id);
      toast.error(result.message, { position: "top-center" });
      getReport();
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleDelete = (rowData) => {
    deleteReport(rowData);
  };

  const columns = [
    {
      name: "name", label: "Name",
      options: {
        customBodyRender: (value, tableMeta) => {
          const name = data[tableMeta.rowIndex].user_id.name;
          return name;
        }
      }
    },
    {
      name: "phone", label: "Phone",
      options: {
        customBodyRender: (value, tableMeta) => {
          const phone = data[tableMeta.rowIndex].user_id.mobile;
          return phone;
        }
      }
    },
    { name: "type", label: "Type" },
    {
      name: "summary",
      label: "Summary",
    },
    {
      name: "description",
      label: "Description",
      options: {
    customBodyRender: (value) => (
      <TruncatedText text={value} maxLength={3} />
    ),
  },
    },

    {
      name: "Action",
      options: {
        customBodyRenderLite: (dataIndex) => (
          <>
            <DeleteIcon
              className="red icon"
              onClick={() => handleDelete(data[dataIndex])}
            />
          </>
        ),
      },
    },
  ];


  const options = {
    filterType: "checkbox",
    print: "false",
    download: "false",
    viewColumns: "false",
    filter: false,
    selectableRows: false,
    // customToolbar: addButton,
  };

  const getReport = async () => {
    setLoading(true);
    try {
      const result = await report();
      setData(result.data);

      console.log(result);
    } catch (error) {
      setLoading(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    //setData(users); // Load JSON data into state
    getReport();
  }, []);

  return (
    <>
      {loading ? (
        <div
          style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <ToastContainer autoClose={1000} />
          <MUIDataTable
            title={"Reports List"}
            data={data}
            columns={columns}
            options={options}
          />
        </>
      )}
    </>
  );
};

export default Reports;
